import { render, staticRenderFns } from "./payFail.vue?vue&type=template&id=667aad88&scoped=true&"
import script from "./payFail.vue?vue&type=script&lang=js&"
export * from "./payFail.vue?vue&type=script&lang=js&"
import style0 from "./payFail.vue?vue&type=style&index=0&id=667aad88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667aad88",
  null
  
)

export default component.exports